const initialState = {};

export const handleNotifications = (state = initialState, action) => {
    switch (action.type) {
        case "clearAllNotifications": return state = {}
        case "setNotifications": return state =  {...state, ...action.notifications}  
        default: return state
    }

}

export default handleNotifications;